/** en-GB messages added by Phase 4 security task SEC1. */
export const sec1EnGB = {
    'auth.error.sso_session_confined': 'This Microsoft sign-in only covers the organisation you signed in to. Sign in with your password to open another organisation.',
};
//# sourceMappingURL=sec1.js.map